import { apiRequest, serviceDetail } from "../../../../services/adapters/base";

class DetailRepository {
	fetchDetail = async (query) => {
		return await apiRequest(
			"get",
			serviceDetail,
			{
				params: query,
			},
			true
		);
	};
}

export default DetailRepository;
